<template>
  <v-stepper v-model="dadosCadastraisFormStep">
    <v-stepper-header>
      <template v-for="index in quantidadePassos">
        <v-stepper-step :key="index" :step="index"></v-stepper-step>
        <v-divider
          v-if="index !== quantidadePassos"
          :key="'d' + index"
        ></v-divider>
      </template>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content
        v-for="index in quantidadePassos"
        :key="index"
        :step="index"
      >
        <v-card v-if="index === 1" outlined class="mb-8 mx-2 pa-2">
          <v-form
            ref="formDadosCadastrais"
            v-model="validformDadosCadastrais"
            lazy-validation
          >
            <v-row>
              <v-col cols="12" md="12" class="pt-2 pb-1">
                <v-text-field
                  v-model="dadosCadastrais.nome"
                  :label="locale[local].screen.formDadosCadastrais.nameLavel"
                  filled
                  @keyup="adjustName"
                  :rules="[
                    (v) => !!v || locale[local].rules.nomeObrigatorioLabel,
                  ]"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-0 pb-2">
                <div class="d-flex">
                  <v-file-input
                    v-model="dadosCadastrais.comprovante"
                    chips
                    :rules="comprovanteRules"
                    show-size
                    :label="
                      locale[local].screen.formDadosCadastrais
                        .comprovanteLabelNome
                    "
                    filled
                  >
                  </v-file-input>
                  <v-tooltip v-model="showTooltip" top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="pt-3">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon color="grey lighten-1">
                            mdi-information
                          </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{
                      locale[local].screen.formDadosCadastrais
                        .comprovanteLabelInfoNome
                    }}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="dadosCadastrais.telefone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  return-masked-value
                  :label="locale[local].screen.formDadosCadastrais.phoneLabel"
                  :rules="foneRules"
                  filled
                  :disabled="showFone"
                  requerid
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="dadosCadastrais.celular"
                  v-mask="maskCel"
                  return-masked-value
                  :label="locale[local].screen.formDadosCadastrais.celLavel"
                  :rules="celularRules"
                  filled
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pt-0 pb-0">
                <v-text-field
                  v-model="dadosCadastrais.email"
                  :label="locale[local].screen.formDadosCadastrais.emailLabel"
                  filled
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card>

        <v-card
          v-if="
            (index === 1 && quantidadePassos === 2) ||
            (index === 2 && quantidadePassos === 3)
          "
          outlined
          class="mb-8 mx-2 pa-2"
        >
          <v-form
            ref="formDadosCadastraisEndereco"
            v-model="validformDadosCadastraisEndereco"
            lazy-validation
          >
            <v-row>
              <v-col cols="12" md="4" class="pt-2 pb-2">
                <v-select
                  v-model="dadosCadastrais.logradouro"
                  :items="publicPlaces"
                  item-text="descricao"
                  item-value="codTipoLogradouro"
                  :rules="[
                    (v) =>
                      !!v || locale[local].rules.logradouroObrigatorioLabel,
                  ]"
                  :label="
                    locale[local].screen.formDadosCadastrais.logradouroLabel
                  "
                  filled
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="8" class="pt-2 pb-2">
                <v-text-field
                  v-model="dadosCadastrais.endereco"
                  :label="
                    locale[local].screen.formDadosCadastrais.enderecoLabel
                  "
                  filled
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-text-field
                  v-model="dadosCadastrais.numero"
                  :label="locale[local].screen.formDadosCadastrais.numeroLabel"
                  filled
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-text-field
                  v-model="dadosCadastrais.complemento"
                  :label="
                    locale[local].screen.formDadosCadastrais.complementoLabel
                  "
                  filled
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-text-field
                  v-model="dadosCadastrais.cep"
                  @blur="getCidadeCEP"
                  v-mask="maskCep"
                  return-masked-value
                  label="CEP"
                  :rules="cepRules"
                  filled
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-text-field
                  v-model="dadosCadastrais.bairro"
                  :label="locale[local].screen.formDadosCadastrais.bairroLabel"
                  filled
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-text-field
                  v-model="dadosCadastrais.cidade"
                  :label="locale[local].screen.formDadosCadastrais.cidadeLabel"
                  filled
                  required
                  :disabled="desabilitarLocalidade"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-select
                  v-model="dadosCadastrais.uf"
                  :items="federatedUnits"
                  item-text="nome"
                  item-value="codUf"
                  :rules="[
                    (v) => !!v || locale[local].rules.ufObrigatorioLabel,
                  ]"
                  label="UF"
                  filled
                  required
                  :disabled="desabilitarLocalidade"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-0 pb-2">
                <div class="d-flex">
                  <v-file-input
                    v-model="dadosCadastrais.enderecoAnexo"
                    chips
                    :rules="enderecoRules"
                    show-size
                    :label="
                      locale[local].screen.formDadosCadastrais
                        .comprovanteLabelEndereco
                    "
                    filled
                  >
                  </v-file-input>
                  <v-tooltip v-model="showTooltipEndereco" top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="pt-3">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon color="grey lighten-1">
                            mdi-information
                          </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{
                      locale[local].screen.formDadosCadastrais
                        .comprovanteLabelInfoEndereco
                    }}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card>

        <v-card
          v-if="
            (index === 2 && quantidadePassos === 2) ||
            (index === 3 && quantidadePassos === 3)
          "
          outlined
          class="mb-8 mx-2 pa-2"
        >
          <v-form
            ref="formDadosCadastraisOutros"
            v-model="validformDadosCadastraisOutros"
            lazy-validation
          >
            <v-row>
              <v-col cols="12" md="5" class="pt-2 pb-2">
                <v-select
                  v-model="dadosCadastrais.estadoCivil"
                  :items="maritalStates"
                  item-text="descricao"
                  item-value="codEstadoCivil"
                  :rules="estadoCivilRules"
                  :label="
                    locale[local].screen.formDadosCadastrais.estadoCivilLabel
                  "
                  filled
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="7" class="pt-2 pb-2">
                <v-text-field
                  v-model="dadosCadastrais.conjuge"
                  :label="locale[local].screen.formDadosCadastrais.conjugeLabel"
                  filled
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-0 pb-2">
                <div class="d-flex">
                  <v-file-input
                    v-model="dadosCadastrais.estadoCivilAnexo"
                    chips
                    :rules="estadoCivilAnexoRules"
                    show-size
                    :label="
                      locale[local].screen.formDadosCadastrais
                        .comprovanteLabelEstadoCivil
                    "
                    filled
                  >
                  </v-file-input>
                  <v-tooltip v-model="showTooltipEstadoCivil" top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="pt-3">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon color="grey lighten-1">
                            mdi-information
                          </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{
                      locale[local].screen.formDadosCadastrais
                        .comprovanteLabelInfoEstadoCivil
                    }}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="8" class="pt-2 pb-2">
                <v-select
                  v-model="dadosCadastrais.grauInstrucao"
                  :items="levelsOfEducation"
                  item-text="descricao"
                  item-value="codGrau"
                  :rules="[
                    (v) =>
                      !!v || locale[local].rules.grauInstrucaoObrigatorioLabel,
                  ]"
                  :label="
                    locale[local].screen.formDadosCadastrais.grauInstrucaoLabel
                  "
                  filled
                  required
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-0 pb-2">
                <div class="d-flex">
                  <v-file-input
                    v-model="dadosCadastrais.grauInstrucaoAnexo"
                    chips
                    :rules="grauInstrucaoRules"
                    show-size
                    :label="
                      locale[local].screen.formDadosCadastrais
                        .comprovanteLabelGrauInstrucao
                    "
                    filled
                  >
                  </v-file-input>
                  <v-tooltip v-model="showTooltipGrauInstrucao" top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="pt-3">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon color="grey lighten-1">
                            mdi-information
                          </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{
                      locale[local].screen.formDadosCadastrais
                        .comprovanteLabelInfoGrauInstrucao
                    }}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-0 pb-2">
                <v-text-field
                  v-model="dadosCadastrais.observacao"
                  :label="
                    locale[local].screen.formDadosCadastrais.observacaoLabel
                  "
                  filled
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-0 pb-2">
                <div class="d-flex">
                  <v-file-input
                    v-model="dadosCadastrais.imagem"
                    chips
                    :rules="imagemRules"
                    show-size
                    :label="
                      locale[local].screen.formDadosCadastrais
                        .comprovanteLabelImagem
                    "
                    filled
                  >
                  </v-file-input>
                  <v-tooltip v-model="showTooltipImagem" top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="pt-3">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon color="grey lighten-1">
                            mdi-information
                          </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{
                      locale[local].screen.formDadosCadastrais
                        .comprovanteLabelInfoImagem
                    }}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card>

        <v-btn v-if="index === 1" text @click="cancelEdit" class="mr-2">{{
          locale[local].screen.formDadosCadastrais.btnCancelar
        }}</v-btn>

        <v-btn v-if="index > 1" text @click="backStep(index)" class="mr-2">{{
          locale[local].screen.formDadosCadastrais.btnVoltar
        }}</v-btn>

        <v-btn
          v-if="index === quantidadePassos"
          :loading="loadingButton"
          :disabled="loadingButton"
          color="primary"
          @click="goStep(index)"
        >
          {{ locale[local].screen.formDadosCadastrais.btnGravar }}
        </v-btn>

        <v-btn v-else color="primary" @click="goStep(index)">
          {{ locale[local].screen.formDadosCadastrais.btnAvancar }}
        </v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import Service from "@/components/api/Service";
import Util from "@/components/api/Util";
import { locale } from "../../locale/locale";

export default {
  data: (vm) => ({
    service: new Service(),
    util: new Util(),

    showTooltip: false,
    showTooltipEndereco: false,
    showTooltipEstadoCivil: false,
    showTooltipGrauInstrucao: false,
    showTooltipImagem: false,
    desabilitarLocalidade: false,

    // Stepper
    dadosCadastraisFormStep: 0,
    quantidadePassos: 2,

    // Loaders
    loadingButton: false,

    //
    dadosCadastrais: {
      nome: "",
      telefone: "",
      email: "",
      celular: "",
      observacao: "",
    },

    //OldValues
    oldDadosCadastrais: {
      nome: "",
      estadoCivil: null,
      conjuge: "",
      grauInstrucao: null,
      cep: "",
      logradouro: "",
      endereco: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      uf: "",
    },

    //Fonte Dados
    publicPlaces: [],
    federatedUnits: [],
    maritalStates: [],
    levelsOfEducation: [],

    // Mascaras
    maskCep: "#####-###",
    maskCel: "(##) #####-####",

    //Validadores
    validformDadosCadastrais: true,
    validformDadosCadastraisEndereco: true,
    validformDadosCadastraisOutros: true,
    showFone: process.env.VUE_APP_CLIENTE === "VENCETUDO" ? true : false,

    // Regras de Validação
    cepRules: [
      (v) => !!v || locale[window.local].rules.cepLabel,
      (v) => (v && v.length >= 9) || locale[window.local].rules.invalidCepLabel,
    ],
    estadoCivilRules: [
      (v) => !!v || locale[window.local].rules.estadoCivilLabel,
      (v) =>
        vm.validaNomeEstadoCivil(v) ||
        locale[window.local].rules.estadoCivilComNomeLabel,
    ],
    comprovanteRules: [
      (v) =>
        vm.validaComprovante(v) || locale[window.local].rules.comprovanteLabel,
    ],
    enderecoRules: [
      (v) =>
        vm.validaEndereco(v) || locale[window.local].rules.comprovanteLabel,
    ],
    grauInstrucaoRules: [
      (v) =>
        vm.validaGruaInstrucao(v) ||
        locale[window.local].rules.comprovanteLabel,
    ],
    estadoCivilAnexoRules: [
      (v) =>
        vm.validaEstadoCivil(v) || locale[window.local].rules.comprovanteLabel,
    ],
    imagemRules: [
      /*(v) =>
        vm.validaComprovante(v) || locale[window.local].rules.comprovanteLabelGrauInstrucao,*/
    ],
    foneRules: [
      (v) =>
        v.length == 0 ||
        v.length >= 14 ||
        locale[window.local].rules.telefoneInvalidoLabel,
      (v) =>
        !v.startsWith("(0") ||
        locale[window.local].rules.telefoneMaiorQueZeroLabel,
    ],
    celularRules: [
      (v) =>
        v.length == 0 ||
        v.length >= 15 ||
        locale[window.local].rules.celularInvalidoLabel,
      (v) =>
        !v.startsWith("(0") ||
        locale[window.local].rules.celularMaiorQueZeroLabel,
    ],
  }),
  methods: {
    cancelEdit() {
      this.$emit("esconder-formulario");
    },
    limparFormulario() {
      if (process.env.NODE_ENV === "production") {
        this.dadosCadastrais = {};
      }
      this.dadosCadastraisFormStep = 1;
    },
    goStep(step) {
      if (step == 1 && this.quantidadePassos === 3) {
        if (this.$refs.formDadosCadastrais[0].validate()) {
          this.dadosCadastraisFormStep = 2;
        }
      } else if (step == 1 && this.quantidadePassos === 2) {
        if (
          this.$refs.formDadosCadastrais[0].validate() &&
          this.$refs.formDadosCadastraisEndereco[0].validate()
        ) {
          this.dadosCadastraisFormStep = 2;
        }
      } else if (step == 2 && this.quantidadePassos === 3) {
        if (this.$refs.formDadosCadastraisEndereco[0].validate()) {
          this.dadosCadastraisFormStep = 3;
        }
      } else if (step === this.quantidadePassos) {
        if (this.$refs.formDadosCadastraisOutros[0].validate()) {
          this.updadePersonalData();
        }
      }
    },
    backStep(passoAtual) {
      if (passoAtual > 1) {
        this.dadosCadastraisFormStep = passoAtual - 1;
      } else {
        this.$emit("esconder-formulario");
      }
    },
    async getCidadeCEP() {
      try {
        this.desabilitarLocalidade = false;

        var response = await this.service.getCidadeCEP(
          this.dadosCadastrais.cep
        );

        if (
          response.data.localidade !== null &&
          response.data.localidade !== "" &&
          response.data.localidade !== undefined
        ) {
          this.dadosCadastrais.bairro = "";
          this.dadosCadastrais.cidade = "";
          this.dadosCadastrais.uf = null;
          this.dadosCadastrais.bairro = response.data.bairro;
          this.dadosCadastrais.cidade = response.data.localidade;
          this.dadosCadastrais.uf = response.data.uf;
          this.desabilitarLocalidade = true;
        } else {
          this.dadosCadastrais.bairro = "";
          this.dadosCadastrais.cidade = "";
          this.dadosCadastrais.uf = null;
        }
      } catch (error) {
        this.desabilitarLocalidade = false;
      }
    },
    async updadePersonalData() {
      try {
        if (this.verificaAlteracoes()) {
          throw new Error(
            locale[window.local].screen.formDadosCadastrais.error01Label
          );
        }

        this.loadingButton = true;
        var data = new Date().toLocaleDateString("pt-BR");
        var dataMovimento = this.util.parseDate(data);

        var dadosCadastrais = {
          codPessoa: parseInt(localStorage.getItem("codPessoa")),
          nome: this.util
            .normalizeString(this.dadosCadastrais.nome)
            .toUpperCase(),
          codCep: this.dadosCadastrais.cep,
          codTipoLogradouro: this.dadosCadastrais.logradouro,
          endereco: this.util
            .normalizeString(this.dadosCadastrais.endereco)
            .toUpperCase(),
          numEnd: parseInt(this.dadosCadastrais.numero),
          complEnd: this.util
            .normalizeString(this.dadosCadastrais.complemento)
            .toUpperCase(),
          bairro: this.util
            .normalizeString(this.dadosCadastrais.bairro)
            .toUpperCase(),
          cidade: this.util
            .normalizeString(this.dadosCadastrais.cidade)
            .toUpperCase(),
          codUf: this.dadosCadastrais.uf,
          fone: this.dadosCadastrais.telefone,
          celular: this.dadosCadastrais.celular,
          emailParticular: this.dadosCadastrais.email.toLowerCase(),
          codEstadoCivil: this.dadosCadastrais.estadoCivil,
          codGrau: this.dadosCadastrais.grauInstrucao,
          nomeConjuge: this.util
            .normalizeString(this.dadosCadastrais.conjuge)
            .toUpperCase(),
          observacao: this.dadosCadastrais.observacao
            ? this.dadosCadastrais.observacao.toUpperCase()
            : "",
          dtMovto: dataMovimento,
        };

        var resposta = await this.service.gravarDadosCadastrais(
          dadosCadastrais
        );

        if (resposta.status === 200) {
          if (resposta.data.logErroApp) {
            throw new Error(resposta.data.logErroApp[0].erro);
          }

          var respostaUploadImagem = {};
          var lErro = false;

          if (this.dadosCadastrais.comprovante) {
            respostaUploadImagem =
              await this.service.uploadImagemAtualizacaoCadastral(
                this.dadosCadastrais.comprovante,
                this.util.formatDate(dataMovimento) + "|1"
              );

            if (respostaUploadImagem.status != 200) {
              lErro = true;
            }
          }

          if (lErro === false) {
            if (this.dadosCadastrais.enderecoAnexo) {
              respostaUploadImagem =
                await this.service.uploadImagemAtualizacaoCadastral(
                  this.dadosCadastrais.enderecoAnexo,
                  this.util.formatDate(dataMovimento) + "|2"
                );

              if (respostaUploadImagem.status != 200) {
                lErro = true;
              }
            }
          }

          if (lErro === false) {
            if (this.dadosCadastrais.estadoCivilAnexo) {
              respostaUploadImagem =
                await this.service.uploadImagemAtualizacaoCadastral(
                  this.dadosCadastrais.estadoCivilAnexo,
                  this.util.formatDate(dataMovimento) + "|3"
                );

              if (respostaUploadImagem.status != 200) {
                lErro = true;
              }
            }
          }

          if (lErro === false) {
            if (this.dadosCadastrais.grauInstrucaoAnexo) {
              respostaUploadImagem =
                await this.service.uploadImagemAtualizacaoCadastral(
                  this.dadosCadastrais.grauInstrucaoAnexo,
                  this.util.formatDate(dataMovimento) + "|4"
                );

              if (respostaUploadImagem.status != 200) {
                lErro = true;
              }
            }
          }

          if (lErro === false) {
            if (this.dadosCadastrais.imagem) {
              respostaUploadImagem =
                await this.service.uploadImagemAtualizacaoCadastral(
                  this.dadosCadastrais.imagem,
                  this.util.formatDate(dataMovimento) + "|5"
                );
            }
          }

          var mensagem = "";
          var tipoMensagem = "";

          if (this.dadosCadastrais.comprovante === null || lErro === false) {
            mensagem =
              locale[window.local].screen.formDadosCadastrais.error02Label;
            tipoMensagem = "Sucesso";
          } else {
            const respostaExcluirWebPessoa =
              await this.service.excluirWebPessoa(dataMovimento);

            if (respostaExcluirWebPessoa.status !== 200) {
              mensagem =
                locale[window.local].screen.formDadosCadastrais.error04Label;
              tipoMensagem = "Erro";
            } else {
              if (this.dadosCadastrais.comprovante) {
                mensagem =
                  locale[window.local].screen.formDadosCadastrais.error05Label;
                tipoMensagem = "Alerta";
              }
            }
          }

          this.loadingButton = false;

          this.$emit("esconder-formulario");
          this.$emit("mostrar-mensagem", mensagem, tipoMensagem);
        } else {
          throw new Error(
            locale[window.local].screen.formDadosCadastrais.error06Label
          );
        }
      } catch (erro) {
        this.loadingButton = false;
        this.$emit("mostrar-alerta", erro.message);
      }
    },
    populateEditsFields(personalDataFromApi) {
      this.dadosCadastrais.nome = personalDataFromApi.nome;
      this.dadosCadastrais.telefone = personalDataFromApi.fone;
      this.dadosCadastrais.celular = personalDataFromApi.celular;
      this.dadosCadastrais.email = personalDataFromApi.emailParticular;
      this.dadosCadastrais.logradouro = personalDataFromApi.codTipoLogradouro;
      this.dadosCadastrais.endereco = personalDataFromApi.endereco;
      this.dadosCadastrais.numero = personalDataFromApi.numEnd;
      this.dadosCadastrais.complemento = personalDataFromApi.complEnd;
      this.dadosCadastrais.bairro = personalDataFromApi.bairro;
      this.dadosCadastrais.cep = personalDataFromApi.codCep;
      this.dadosCadastrais.cidade = personalDataFromApi.cidade;
      this.dadosCadastrais.uf = personalDataFromApi.codUf;
      // Solicitar para API trazer codEstadoCivil;
      this.dadosCadastrais.estadoCivil = this.maritalStates.filter(
        (x) => x.descricao === personalDataFromApi.estadoCivil
      )[0].codEstadoCivil;
      this.dadosCadastrais.conjuge = personalDataFromApi.nomeConjuge;
      // Solicitar para API trazer o codGrau
      this.dadosCadastrais.grauInstrucao = this.levelsOfEducation.filter(
        (x) => x.descricao === personalDataFromApi.grauInstrucao
      )[0].codGrau;

      this.oldDadosCadastrais = { ...this.dadosCadastrais };

      //Dados para comparação
      this.oldDadosCadastrais.nome = personalDataFromApi.nome;
      this.oldDadosCadastrais.estadoCivil = this.maritalStates.filter(
        (x) => x.descricao === personalDataFromApi.estadoCivil
      )[0].codEstadoCivil;
      this.oldDadosCadastrais.grauInstrucao = this.levelsOfEducation.filter(
        (x) => x.descricao === personalDataFromApi.grauInstrucao
      )[0].codGrau;
      this.oldDadosCadastrais.cep = personalDataFromApi.codCep;
      this.oldDadosCadastrais.conjuge = personalDataFromApi.nomeConjuge;
      this.oldDadosCadastrais.logradouro =
        personalDataFromApi.codTipoLogradouro;
      this.oldDadosCadastrais.endereco = personalDataFromApi.endereco;
      this.oldDadosCadastrais.numero = personalDataFromApi.numEnd;
      this.oldDadosCadastrais.complemento = personalDataFromApi.complEnd;
      this.oldDadosCadastrais.bairro = personalDataFromApi.bairro;
      this.oldDadosCadastrais.cidade = personalDataFromApi.cidade;
      this.oldDadosCadastrais.uf = personalDataFromApi.codUf;
      this.oldDadosCadastrais.telefone = personalDataFromApi.fone;
      this.oldDadosCadastrais.celular = personalDataFromApi.celular;
      this.oldDadosCadastrais.email = personalDataFromApi.emailParticular;

      this.dadosCadastrais.comprovante = null;
      this.dadosCadastrais.enderecoAnexo = null;
      this.dadosCadastrais.estadoCivilAnexo = null;
      this.dadosCadastrais.grauInstrucaoAnexo = null;
      this.dadosCadastrais.imagem = null;
    },
    adjustName() {
      this.dadosCadastrais.nome = this.dadosCadastrais.nome.toUpperCase();
      this.dadosCadastrais.nome = this.dadosCadastrais.nome
        .normalize("NFD")
        .replace(/[\u0300-\u036f]|[^0-9a-zA-Z\s]/g, "");
    },
    validaNomeEstadoCivil(estadoCivil) {
      if (this.dadosCadastrais?.nome) {
        if (
          this.dadosCadastrais.nome.toUpperCase() !=
          this.oldDadosCadastrais.nome.toUpperCase()
        ) {
          if (
            this.oldDadosCadastrais.estadoCivil === estadoCivil &&
            this.$alteracaoNomeObrigaEstadoCivil == true
          ) {
            return false;
          }
        }
      }

      return true;
    },
    validaComprovante(comprovante) {
      if (this.dadosCadastrais?.nome) {
        if (
          this.dadosCadastrais.nome.toUpperCase() !=
          this.oldDadosCadastrais.nome.toUpperCase()
        ) {
          if (!comprovante) {
            return false;
          }
        }
      }

      return true;
    },
    validaEndereco(endereco) {
      if (this.dadosCadastrais?.endereco) {
        if (
          this.dadosCadastrais.cep.replace("-", "") !=
            this.oldDadosCadastrais.cep.replace("-", "") ||
          this.dadosCadastrais.logradouro !=
            this.oldDadosCadastrais.logradouro ||
          this.dadosCadastrais.endereco != this.oldDadosCadastrais.endereco ||
          this.dadosCadastrais.numero != this.oldDadosCadastrais.numero ||
          this.dadosCadastrais.complemento !=
            this.oldDadosCadastrais.complemento ||
          this.dadosCadastrais.bairro != this.oldDadosCadastrais.bairro ||
          this.dadosCadastrais.cidade != this.oldDadosCadastrais.cidade ||
          this.dadosCadastrais.uf != this.oldDadosCadastrais.uf
        ) {
          if (!endereco) {
            return false;
          }
        }
      }

      return true;
    },
    validaGruaInstrucao(grauInstrucao) {
      if (this.dadosCadastrais?.grauInstrucao) {
        if (
          this.dadosCadastrais.grauInstrucao !=
          this.oldDadosCadastrais.grauInstrucao
        ) {
          if (!grauInstrucao) {
            return false;
          }
        }
      }

      return true;
    },
    validaEstadoCivil(estadoCivil) {
      if (this.dadosCadastrais?.estadoCivil) {
        if (
          this.dadosCadastrais.estadoCivil !=
          this.oldDadosCadastrais.estadoCivil
        ) {
          if (!estadoCivil) {
            return false;
          }
        }
      }
      return true;
    },
    verificaAlteracoes() {
      if (this.dadosCadastrais.nome !== this.oldDadosCadastrais.nome) {
        return false;
      }

      if (
        (this.dadosCadastrais.telefone ?? "") !==
        (this.oldDadosCadastrais.telefone ?? "")
      ) {
        return false;
      }

      if (
        this.dadosCadastrais.celular !== (this.oldDadosCadastrais.celular ?? "")
      ) {
        return false;
      }

      if (
        this.dadosCadastrais.email !== (this.oldDadosCadastrais.email ?? "")
      ) {
        return false;
      }

      if (
        this.dadosCadastrais.logradouro !== this.oldDadosCadastrais.logradouro
      ) {
        return false;
      }

      if (this.dadosCadastrais.endereco !== this.oldDadosCadastrais.endereco) {
        return false;
      }

      if (this.dadosCadastrais.numero !== this.oldDadosCadastrais.numero) {
        return false;
      }

      if (
        this.dadosCadastrais.cep.replace("-", "") !==
        this.oldDadosCadastrais.cep.replace("-", "")
      ) {
        return false;
      }

      if (this.dadosCadastrais.bairro !== this.oldDadosCadastrais.bairro) {
        return false;
      }

      if (this.dadosCadastrais.cidade !== this.oldDadosCadastrais.cidade) {
        return false;
      }

      if (this.dadosCadastrais.uf !== this.oldDadosCadastrais.uf) {
        return false;
      }

      if (
        this.dadosCadastrais.estadoCivil !== this.oldDadosCadastrais.estadoCivil
      ) {
        return false;
      }

      if (this.dadosCadastrais.conjuge !== this.oldDadosCadastrais.conjuge) {
        return false;
      }

      if (
        this.dadosCadastrais.grauInstrucao !==
        this.oldDadosCadastrais.grauInstrucao
      ) {
        return false;
      }

      if (
        this.dadosCadastrais.imagem != null && this.dadosCadastrais.imagem != undefined) {
        return false;
      }

      return true;
    },
  },
};
</script>
